/**
 * IMCustomMsgType 枚举
 * 用于区分系统推送事件类型（data.msgType）
 * 触发全局行为：弹窗、Toast、状态更新等
 *
 * 特殊关系：
 * - IMCustomMsgType.PUSH_MSG 包含 MsgBean（有 MsgType）
 */

// ========== 核心消息类型 ==========
export const CORE_TYPES = {
  PUSH_MSG: 'Push_Msg', // 私聊消息（包含 MsgBean） ✅
  TOAST_COMMON: 'TOAST_COMMON', // 通用Toast提示 ✅
  RESTART_LOGIN: 'RESTART_LOGIN', // 用户成为主播时，强制重新登录（misslive没有主播，不需要处理）
  COMMON_NOTICE: 'COMMON_NOTICE', // 统一Toast使用文案 ✅
  PONG: 'PONG' // IM网络检测（心跳检测？已由 IM SDK 实现，客户端也未使用这个消息）
}

// ========== 视频通话相关 ==========
export const VIDEO_CALL_TYPES = {
  LOVE_ROOM_INVITE: 'LOVE_ROOM_INVITE', // 1v1视频匹配邀请 ✅
  LOVE_ROOM_JOIN: 'LOVE_ROOM_JOIN', // 1v1视频匹配成功 ✅
  LOVE_ROOM_REFUSE: 'LOVE_ROOM_REFUSE', // 匹配或1v1拒绝 ✅
  LOVE_ROOM_HANG_UP: 'LOVE_ROOM_HANG_UP', // 挂断 ✅
  LOVE_ROOM_CALL_RECORD: 'LOVE_ROOM_CALL_RECORD', // 通话记录
  LOVE_ROOM_VIDEO_POP: 'LOVE_ROOM_VIDEO_POP', // 视频弹窗
  MSG_INSTEAD_VIDEO_POP: 'MSG_INSTEAD_VIDEO_POP', // 替代视频弹窗
  VIDEO_CALL_MSG_NOTICE: 'VIDEO_CALL_MSG_NOTICE', // 视频通话消息通知 ✅
  LOVE_ROOM_APPOINTMENT_CALLBACK: 'LOVE_ROOM_APPOINTMENT_CALLBACK', // 预约回拨
  PRIVATE_CALL_1V1_CARD_CHANGE: 'PRIVATE_CALL_1V1_CARD_CHANGE', // 私密通话1v1卡片变更
  ANCHOR_VIDEO_CALL_INCOME: 'ANCHOR_VIDEO_CALL_INCOME', // 主播视频通话收益
  MSG_LEAD_VIDEO_POP: 'MSG_LEAD_VIDEO_POP', // 消息引导视频弹窗（通话引导）
  SWIPE_CARD_VIDEO_POP: 'SWIPE_CARD_VIDEO_POP', // 刷卡视频弹窗
  SWIPE_CARD_TALK_POP: 'SWIPE_CARD_TALK_POP' // 刷卡对话弹窗
}

// ========== 直播间相关 ==========
export const LIVE_ROOM_TYPES = {
  LOVE_ROOM_MESSAGE: 'LOVE_ROOM_MESSAGE', // 直播间消息 ✅
  VIDEO_ROOM_BREAK_THE_ROLE: 'VIDEO_ROOM_BREAK_THE_ROLE', // 直播间违规
  VIDEO_ROOM_ILLEGAL: 'VIDEO_ROOM_ILLEGAL', // 违规行为
  VIDEO_ROOM_BANNED: 'VIDEO_ROOM_BANNED', // 封禁消息
  VIDEO_ROOM_ANCHOR_PORNOGRAPHIC: 'VIDEO_ROOM_ANCHOR_PORNOGRAPHIC', // 主播色情内容
  VIDEO_ROOM_PORN_MOSAIC: 'VIDEO_ROOM_PORN_MOSAIC', // 色情马赛克
  SEND_GIFT: 'SEND_GIFT', // 直播间礼物 ✅
  LIVE_THUMB_UP: 'LIVE_THUMB_UP', // 点赞
  ROOM_MATCH_CHANGE_1V1: 'ROOM_MATCH_CHANGE_1V1', // 直播间充值
  ROOM_COST_REMIND: 'ROOM_COST_REMIND', // 随机视频扣费提醒
  LOVE_ROOM_INCOME_GET: 'LOVE_ROOM_INCOME_GET', // 直播间收益获取
  LOVE_ROOM_EXP_CARD_CHANGE: 'LOVE_ROOM_EXP_CARD_CHANGE', // 直播间体验卡变更
  LOVE_ROOM_PREEMPT: 'LOVE_ROOM_PREEMPT', // 直播间抢占
  LOVE_ROOM_RISK_PORN: 'LOVE_ROOM_RISK_PORN', // 直播间色情风险
  LIVE_ROOM_BROADCAST_REMINDER: 'LIVE_ROOM_BROADCAST_REMINDER', // 直播间开播提醒
  LOVE_ROOM_CONSUME_ASSET_TYPE_CHANGE: 'LOVE_ROOM_CONSUME_ASSET_TYPE_CHANGE' // 直播间消费资产类型变更
}

// ========== 用户状态相关 ==========
export const USER_STATUS_TYPES = {
  MEMBER_REMAIN_COIN: 'MEMBER_REMAIN_COIN', // 金币不足提示 ✅
  SYNC_COIN: 'SYNC_COIN', // 同步金币 ✅
  VIP_CHANGE: 'VIP_CHANGE', // VIP变更 ✅
  VIP_LEVEL_UPGRADE: 'VIP_LEVEL_UPGRADE', // VIP等级升级
  WEALTH_LEVEL_UPGRADE: 'WEALTH_LEVEL_UPGRADE', // 财富等级升级
  CONSUME_LEVEL_UPGRADE: 'CONSUME_LEVEL_UPGRADE', // 消费等级升级
  MEMBER_OTHER_AVATAR_AUTH: 'MEMBER_OTHER_AVATAR_AUTH', // 用户头像认证
  MEMBER_REVIEW: 'MEMBER_REVIEW', // 用户审核
  USER_REGISTER_REWARD: 'USER_REGISTER_REWARD', // 用户注册奖励
  RETURNING_USER_TO_APP: 'RETURNING_USER_TO_APP', // 用户回归APP
  USER_BECOME_UNION_MASTER: 'USER_BECOME_UNION_MASTER', // 用户成为公会会长
  RECOMMEND_TAG_CHANGE: 'RECOMMEND_TAG_CHANGE' // 推荐标签变更
}

// ========== 社交互动相关 ==========
export const SOCIAL_TYPES = {
  FRIEND_ONLINE_MSG: 'FRIEND_ONLINE_MSG', // 好友上线消息
  MSG_FOLLOW_REMIND: 'MSG_FOLLOW_REMIND', // 关注提醒
  INTIMACY_VALUE_CHANGE: 'INTIMACY_VALUE_CHANGE', // 亲密度变化
  INTIMACY_INTERACTION_DAYS: 'INTIMACY_INTERACTION_DAYS', // 亲密度互动天数
  COUPLE_APPLY_REPLY: 'COUPLE_APPLY_REPLY', // CP申请回复
  COUPLE_RECOMMEND: 'COUPLE_RECOMMEND', // CP推荐
  BIND_PARTNER: 'BIND_PARTNER', // 绑定伴侣
  CP_INTIMACY_CHANGE: 'CP_INTIMACY_CHANGE', // CP亲密度变化
  SAY_HI_NUM_CHANGE: 'SAY_HI_NUM_CHANGE', // 打招呼次数变更
  INTERACT_ACTION_STATUS: 'INTERACT_ACTION_STATUS' // 互动动作状态
}

// ========== 任务和活动相关 ==========
export const TASK_ACTIVITY_TYPES = {
  DAILY_TASK_COMPLETE: 'DAILY_TASK_COMPLETE', // 每日任务完成
  DAILY_TASK_PROGRESS: 'DAILY_TASK_PROGRESS', // 每日任务进度
  NEWBIE_TASK_FINISH: 'NEWBIE_TASK_FINISH', // 新手任务完成
  BESTIES_TASK_FINISH: 'BESTIES_TASK_FINISH', // 闺蜜任务完成
  DAILY_SIGN_PAID_EXTEND_REWARD: 'DAILY_SIGN_PAID_EXTEND_REWARD', // 每日签到付费扩展奖励
  FREE_USER_PAID_SIGN_POP: 'FREE_USER_PAID_SIGN_POP', // 免费用户付费签到弹窗
  PREMIUM_DAILY_GIFT_BAG: 'PREMIUM_DAILY_GIFT_BAG', // 高级每日礼包
  SEND_LUCKY_GIFT_AWARD: 'SEND_LUCKY_GIFT_AWARD', // 幸运礼物奖励
  ACTIVITY_JACKPOT_REWARD: 'ACTIVITY_JACKPOT_REWARD', // 活动大奖奖励
  USER_AD_REWARD: 'USER_AD_REWARD', // 用户广告奖励
  RECHARGE_FRENZY_UPDATE: 'RECHARGE_FRENZY_UPDATE', // 充值狂欢更新
  MSG_DEPTH_AWARD: 'MSG_DEPTH_AWARD' // 消息深度奖励
}

// ========== 动态和游戏相关 ==========
export const MOMENT_GAME_TYPES = {
  MOMENT_SHOW_IN_CONVERSATION: 'MOMENT_SHOW_IN_CONVERSATION', // 动态显示在会话中
  MOMENT_NOTIFICATION: 'MOMENT_NOTIFICATION', // 动态通知
  MOMENT_INDUCE_MSG: 'MOMENT_INDUCE_MSG', // 动态诱导消息
  GAME_INVITE_POP: 'GAME_INVITE_POP', // 游戏邀请弹窗
  SEND_GAME_TICKETS_REMIND: 'SEND_GAME_TICKETS_REMIND' // 发送游戏门票提醒
}

// ========== 家族/派对房间相关 ==========
export const PARTY_CHATROOM_TYPES = {
  CHAT_ROOM_QUIT_NOTICE: 'CHAT_ROOM_QUIT_NOTICE', // 家族退出通知
  CHAT_ROOM_MSG_PRIVATE: 'CHAT_ROOM_MSG_PRIVATE', // 家族私聊消息
  PARTY_ROOM_NOTICE_GUIDE: 'PARTY_ROOM_NOTICE_GUIDE', // 派对房间通知引导
  PARTY_ROOM_NEWBIE_GIFT_GUIDE: 'PARTY_ROOM_NEWBIE_GIFT_GUIDE', // 派对房间新手礼物引导
  PARTY_ROOM_POP_RECOMMEND: 'PARTY_ROOM_POP_RECOMMEND' // 派对房间弹窗推荐
}

// ========== 其他功能 ==========
export const OTHER_TYPES = {
  GET_USER_LOG: 'GET_USER_LOG', // 服务器主动要求客户端上传日志文件，用于问题排查和反馈。
  ANCHOR_MATCH_TIME_FINISHED: 'ANCHOR_MATCH_TIME_FINISHED', // 主播匹配时间结束
  ANCHOR_TIPS_DIALOG: 'ANCHOR_TIPS_DIALOG', // 主播提示弹窗
  MATCH_SWITCH_OPEN_OFF: 'MATCH_SWITCH_OPEN_OFF', // 匹配开关
  FIREBASE_REPORT_COMMON: 'FIREBASE_REPORT_COMMON', // Firebase通用上报
  SIGNOUT_REMIND: 'SIGNOUT_REMIND', // 用户注销账号之后，会推送该消息，客户端收到需要退出登录
  GIFT_GIVING_GUIDE: 'GIFT_GIVING_GUIDE', // 送礼引导
  PAY_TRIGGERING_RECHARGE_SCENARIOS: 'PAY_TRIGGERING_RECHARGE_SCENARIOS', // 触发充值场景
  ANCHOR_WORK_INVITE: 'ANCHOR_WORK_INVITE', // 主播工作邀请
  PAY_RESULT: 'PAY_RESULT', // 支付结果
  GIFT_SERIES_MEDAL_UNLOCK: 'GIFT_SERIES_MEDAL_UNLOCK', // 礼物系列勋章解锁
  GARDEN_PLAYMATE_ADD_NOTIFY: 'GARDEN_PLAYMATE_ADD_NOTIFY', // 花园玩伴添加通知
  GARDEN_MATURED: 'GARDEN_MATURED', // 花园成熟
  APP_REVIEW_REMIND: 'APP_REVIEW_REMIND' // 应用评论提醒
}

// ========== 所有类型（合并） ==========
export const IMCustomMsgType = {
  ...CORE_TYPES,
  ...VIDEO_CALL_TYPES,
  ...LIVE_ROOM_TYPES,
  ...USER_STATUS_TYPES,
  ...SOCIAL_TYPES,
  ...TASK_ACTIVITY_TYPES,
  ...MOMENT_GAME_TYPES,
  ...PARTY_CHATROOM_TYPES,
  ...OTHER_TYPES
}

export default IMCustomMsgType
